import acresLogo from "@src/assets/tokens/ACRES.svg";
import axlyLogo from "@src/assets/tokens/AXLY.svg";
import bnbLogo from "@src/assets/tokens/BNB.svg";
import btcbLogo from "@src/assets/tokens/BTCB.svg";
import burnxtnLogo from "@src/assets/tokens/BURN-XTN.svg";
import eastLogo from "@src/assets/tokens/EAST.svg";
import eggLogo from "@src/assets/tokens/EGG.svg";
import ethLogo from "@src/assets/tokens/ETH.svg";
import fomoLogo from "@src/assets/tokens/FOMO.jpeg";
import fudtLogo from "@src/assets/tokens/FUDT.svg";
import gxwxLogo from "@src/assets/tokens/GXWX.svg";
import l2mpLogo from "@src/assets/tokens/L2MP.svg";
import leasedwavesLogo from "@src/assets/tokens/LEASEDWAVES.svg";
import nsbtLogo from "@src/assets/tokens/NSBT.svg";
import peteLogo from "@src/assets/tokens/PETE.svg";
import plethLogo from "@src/assets/tokens/PL-ETH.svg";
import plusdtLogo from "@src/assets/tokens/PL-USDT.svg";
import plwavesLogo from "@src/assets/tokens/PL-WAVES.svg";
import plutoLogo from "@src/assets/tokens/PLUTO.svg";
import powerLogo from "@src/assets/tokens/POWER.svg";
import puzzleLogo from "@src/assets/tokens/PUZZLE.svg";
import pz5poolLogo from "@src/assets/tokens/PZ-5POOL.jpeg";
import pzbbbLogo from "@src/assets/tokens/PZ-BBB.jpg";
import pzburnxtnxpptLogo from "@src/assets/tokens/PZ-BURN-XTN-X-PPT.jpg";
import pzburnxtnLogo from "@src/assets/tokens/PZ-BURN-XTN.jpg";
import pzmegapeteLogo from "@src/assets/tokens/PZ-MEGA-PETE.svg";
import pzoldgoldLogo from "@src/assets/tokens/PZ-OLD-GOLD.jpg";
import pzunitsLogo from "@src/assets/tokens/PZ-UNITS.jpg";
import pzwebLogo from "@src/assets/tokens/PZ-WEB.svg";
import romeLogo from "@src/assets/tokens/ROME.svg";
import sashaxLogo from "@src/assets/tokens/SASHA-X.svg";
import sbtLogo from "@src/assets/tokens/SBT.svg";
import signLogo from "@src/assets/tokens/SIGN.svg";
import snsbtLogo from "@src/assets/tokens/SNSBT.png";
import spiceLogo from "@src/assets/tokens/SPICE.svg";
import surfLogo from "@src/assets/tokens/SURF.svg";
import swavesLogo from "@src/assets/tokens/SWAVES.svg";
import swopLogo from "@src/assets/tokens/SWOP.svg";
import tsnLogo from "@src/assets/tokens/TSN.svg";
import unknownlogoLogo from "@src/assets/tokens/UNKNOWN-LOGO.svg";
import usdcbep20Logo from "@src/assets/tokens/USDC-BEP20.svg";
import usdcerc20Logo from "@src/assets/tokens/USDC-ERC20.svg";
import usdcpolyLogo from "@src/assets/tokens/USDC-POLY.svg";
import usdcpptLogo from "@src/assets/tokens/USDC-PPT.svg";
import usdctrc20Logo from "@src/assets/tokens/USDC-TRC20.svg";
import usdtbep20Logo from "@src/assets/tokens/USDT-BEP20.svg";
import usdterc20Logo from "@src/assets/tokens/USDT-ERC20.svg";
import usdtpolyLogo from "@src/assets/tokens/USDT-POLY.svg";
import usdtpptLogo from "@src/assets/tokens/USDT-PPT.svg";
import usdttrc20Logo from "@src/assets/tokens/USDT-TRC20.svg";
import viresLogo from "@src/assets/tokens/VIRES.svg";
import vvxtnlpLogo from "@src/assets/tokens/VVXTNLP.svg";
import wavesLogo from "@src/assets/tokens/WAVES.svg";
import wavesdlpLogo from "@src/assets/tokens/WAVESDLP.svg";
import wbriacashLogo from "@src/assets/tokens/WBRIACASH.svg";
import wbriacashindexlpLogo from "@src/assets/tokens/WBRIACASH-INDEX-LP.svg";
import wbriacashlpLogo from "@src/assets/tokens/WBRIACASH-LP.svg";
import wbtcerc20Logo from "@src/assets/tokens/WBTC-ERC20.svg";
import westLogo from "@src/assets/tokens/WEST.svg";
import whirlpoolLogo from "@src/assets/tokens/WHIRLPOOL.jpeg";
import windLogo from "@src/assets/tokens/WIND.png";
import wlgoldLogo from "@src/assets/tokens/WLGOLD.svg";
import wxLogo from "@src/assets/tokens/WX.svg";
import xtnLogo from "@src/assets/tokens/XTN.svg";

const tokenLogos: Record<string, string> = {
  "ACRES": acresLogo,
  "AXLY": axlyLogo,
  "BNB": bnbLogo,
  "BTCB": btcbLogo,
  "BURN-XTN": burnxtnLogo,
  "EAST": eastLogo,
  "EGG": eggLogo,
  "ETH": ethLogo,
  "FOMO": fomoLogo,
  "FUDT": fudtLogo,
  "GXWX": gxwxLogo,
  "L2MP": l2mpLogo,
  "LEASEDWAVES": leasedwavesLogo,
  "NSBT": nsbtLogo,
  "PETE": peteLogo,
  "PL-ETH": plethLogo,
  "PL-USDT": plusdtLogo,
  "PL-WAVES": plwavesLogo,
  "PLUTO": plutoLogo,
  "POWER": powerLogo,
  "PUZZLE": puzzleLogo,
  "PZ-5POOL": pz5poolLogo,
  "PZ-BBB": pzbbbLogo,
  "PZ-BURN-XTN-X-PPT": pzburnxtnxpptLogo,
  "PZ-BURN-XTN": pzburnxtnLogo,
  "PZ-MEGA-PETE": pzmegapeteLogo,
  "PZ-OLD-GOLD": pzoldgoldLogo,
  "PZ-UNITS": pzunitsLogo,
  "PZ-WEB": pzwebLogo,
  "ROME": romeLogo,
  "SASHA-X": sashaxLogo,
  "SBT": sbtLogo,
  "SIGN": signLogo,
  "SNSBT": snsbtLogo,
  "SPICE": spiceLogo,
  "SURF": surfLogo,
  "SWAVES": swavesLogo,
  "SWOP": swopLogo,
  "TSN": tsnLogo,
  "UNKNOWN-LOGO": unknownlogoLogo,
  "USDC-BEP20": usdcbep20Logo,
  "USDC-ERC20": usdcerc20Logo,
  "USDC-POLY": usdcpolyLogo,
  "USDC-PPT": usdcpptLogo,
  "USDC-TRC20": usdctrc20Logo,
  "USDT-BEP20": usdtbep20Logo,
  "USDT-ERC20": usdterc20Logo,
  "USDT-POLY": usdtpolyLogo,
  "USDT-PPT": usdtpptLogo,
  "USDT-TRC20": usdttrc20Logo,
  "VIRES": viresLogo,
  "VVXTNLP": vvxtnlpLogo,
  "WAVES": wavesLogo,
  "WAVESDLP": wavesdlpLogo,
  "WBRIACASH": wbriacashLogo,
  "WBRIACASH-INDEX-LP": wbriacashindexlpLogo,
  "WBRIACASH-LP": wbriacashlpLogo,
  "WBTC-ERC20": wbtcerc20Logo,
  "WEST": westLogo,
  "WHIRLPOOL": whirlpoolLogo,
  "WIND": windLogo,
  "WLGOLD": wlgoldLogo,
  "WX": wxLogo,
  "XTN": xtnLogo,
};

export default tokenLogos;
